import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { AndExpression } from "@seriously-rad/seriouslyrad-framework-core/Expressions/AndExpression";
import { ComparisonExpression, ComparisonExpressionOperatorEnum } from "@seriously-rad/seriouslyrad-framework-core/Expressions/ComparisonExpression";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { ControlRef } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ControlRef";
import { IParameterDialog, ParameterDialog, ParameterDialogPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ParameterDialog";
import { PropertyEditorComboBoxLookupItem } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorComboBoxLookupItem";
import { PropertyEditorTextBoxMedium } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorTextBoxMedium";

export type CaseEmailFilterParameterDialogPropertyValues =
    ParameterDialogPropertyValues
    & {
    };

export type CaseEmailFilterParameterDialogProperties = {
    [name in keyof CaseEmailFilterParameterDialogPropertyValues]: Property<CaseEmailFilterParameterDialogPropertyValues[name]>
};

export interface ICaseEmailFilterParameterDialog extends IParameterDialog, CaseEmailFilterParameterDialogProperties
{
}

export class CaseEmailFilterParameterDialog extends ParameterDialog implements ICaseEmailFilterParameterDialog
{
    // #region Static

    // #region Overrides

    // #region Methods

    public static override createPropertyDefaults(): PartialNullable<CaseEmailFilterParameterDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                buttonStyle: ButtonStyleEnum.okCancel,
            }
        };
    }

    // #endregion

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    private propertyEditorCaseReferenceControlRef?: ControlRef<PropertyEditorTextBoxMedium>;
    private propertyEditorStatusControlRef?: ControlRef<PropertyEditorComboBoxLookupItem>;
    private propertyEditorTypeControlRef?: ControlRef<PropertyEditorComboBoxLookupItem>;

    // #endregion

    // #region Overrides

    protected override _createChildrenHtml()
    {
        this.propertyEditorCaseReferenceControlRef = new ControlRef<PropertyEditorTextBoxMedium>;
        this.propertyEditorStatusControlRef = new ControlRef<PropertyEditorComboBoxLookupItem>;
        this.propertyEditorTypeControlRef = new ControlRef<PropertyEditorComboBoxLookupItem>;

        return (
            <>
                <PropertyEditorTextBoxMedium ref={this.propertyEditorCaseReferenceControlRef} editMode={true} propertyDisplayName="Case Reference" />
                <PropertyEditorComboBoxLookupItem ref={this.propertyEditorTypeControlRef} editMode={true} lookupType="Case Email Types" propertyDisplayName="Type" />
                <PropertyEditorComboBoxLookupItem ref={this.propertyEditorStatusControlRef} editMode={true} lookupType="Case Email Statuses" propertyDisplayName="Status" />
            </>
        );
    }

    public override createExpression()
    {
        const
            expression = new AndExpression(),
            caseReference = this.propertyEditorCaseReferenceControlRef?.current?.value.get(),
            type = this.propertyEditorTypeControlRef?.current?.value.get(),
            status = this.propertyEditorStatusControlRef?.current?.value.get();

        if (caseReference)
            expression.add(new ComparisonExpression({ operator: ComparisonExpressionOperatorEnum.contains, path: "case.caseReference", value: caseReference }));

        if (type)
            expression.add(new ComparisonExpression({ path: "typeLookupItemId", value: type }));

        if (status)
            expression.add(new ComparisonExpression({ path: "statusLookupItemId", value: status }));

        return expression.count() > 0 ? expression : null;
    }
    public override openAsync()
    {
        const
            dataSource = new DataSource({ data: {} });

        this.propertyEditorCaseReferenceControlRef?.current?.dataSource.set(dataSource);
        this.propertyEditorTypeControlRef?.current?.dataSource.set(dataSource);
        this.propertyEditorStatusControlRef?.current?.dataSource.set(dataSource);

        return super.openAsync();
    }

    // #endregion

    // #endregion
}
